<template>
    <div>
        <!-- 注：添加操作时，当左边没有树的值传入时，添加需要默认清空内容defaultEmpty，但包含树图或有内容传入时需要去掉该属性 -->
        <base-form-plus :isAdd="formInfo.isAdd" :relationDialogVisible.sync="formInfo.dialogVisible" showTitle="模型配置表"
                  :showData="formInfo.editData"
                  :rules="rules" @submitAdd="submitAdd" @submitEdit="submitEdit" ref="baseForm" defaultEmpty>
            <!-- 插槽部分 -->
            <template v-slot:default="{ruleForm}" class="info">
                        <!-- 提供商名称 -->
                        <el-form-item :label="columnInfo.providerName.label" prop="providerName">
                                <el-input v-model="ruleForm.providerName" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 协议类型 -->
                        <el-form-item :label="columnInfo.protocolType.label" prop="protocolType">
                                <enum-dict-select v-model="ruleForm.protocolType" module-name="data" dict-code="protocolType"></enum-dict-select>
                        </el-form-item>
                        <!-- 接口基础地址 -->
                        <el-form-item :label="columnInfo.baseUrl.label" prop="baseUrl">
                                <el-input v-model="ruleForm.baseUrl" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 接口密钥 -->
                        <el-form-item :label="columnInfo.apiKey.label" prop="apiKey">
                                <el-input v-model="ruleForm.apiKey" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 模型名称 -->
                        <el-form-item :label="columnInfo.modelName.label" prop="modelName">
                                <el-input v-model="ruleForm.modelName" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 是否默认 -->
                        <el-form-item :label="columnInfo.isDefault.label" prop="isDefault">
                                <enum-dict-select v-model="ruleForm.isDefault" module-name="data" dict-code="binary"></enum-dict-select>
                        </el-form-item>
                        <!-- 描述 -->
                        <el-form-item :label="columnInfo.description.label" prop="description">
                                <el-input v-model="ruleForm.description" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 状态 -->
                        <el-form-item :label="columnInfo.state.label" prop="state">
                                <enum-dict-select v-model="ruleForm.state" module-name="data" dict-code="state"></enum-dict-select>
                        </el-form-item>
            </template>
        </base-form-plus>
    </div>
</template>

<script>
    /**
     * 	模型配置表表单
     * 	@author PeterLee
     * 	@since 2026-05-21
     */
    import {mapState, mapMutations, mapActions} from "vuex";

    export default {
        name: 'modelConfigForm',
        // 计算操作
        computed: {
            ...mapState({
                // 校验规则
                rules: state => state.data.modelConfig.rules,
                // 表格数据
                tableData: state => state.data.modelConfig.tableData,
                // 表单信息
                formInfo: state => state.data.modelConfig.formInfo,
                // 下拉选项
                options: state => state.data.modelConfig.options,
                // 列信息
                columnInfo: state => state.data.modelConfig.columnInfo,
            })
        },
        methods: {
            ...mapMutations({
                setDialogVisible: 'data/modelConfig/setDialogVisible',
            }),
            ...mapActions({
                submitAdd: 'data/modelConfig/submitAdd',
                submitEdit: 'data/modelConfig/submitEdit',
            })
        }
    }
</script>

<style lang="less" scoped>
    .info {
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
            width: 50%;
        }
    }
</style>
